import { Component, input } from '@angular/core';
import type { OpenClosePanelName, SummaryLateralModuleName } from '@appTypes';
import { DatePicker } from '@shared/controls/date-picker/date-picker';
import { InputText } from '@shared/controls/input-text/input-text';
import { Radio } from '@shared/controls/radio/radio';

@Component({
  selector: 'app-summary-lateral-panel',
  standalone: true,
  imports: [InputText, Radio, DatePicker],
  templateUrl: './summary-lateral-panel.html',
  styles: `
    :host {
      width: 100%;
    }
  `,
})
export class SummaryLateralPanel {
  $moduleName = input.required<SummaryLateralModuleName>({ alias: 'moduleName' });
  $panelName = input.required<OpenClosePanelName>({ alias: 'panelName' });
  today = new Date();
}
